// ============================================================================
// TRIE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'trie',
  name: 'Trie',
  category: 'Data Structures',
  complexity: {
    time: 'O(L) per operation (L = key length)',
    space: 'O(N * L)'
  },
  description: 'Also known as a prefix tree, it stores strings in a tree structure where each node represents a character. Enables efficient prefix searches, autocomplete, and dictionary operations with time proportional to key length.'
};
